import React, { Component } from "react"

export default class NotificationsDropdown extends Component {
  render() {
    return (
      <li class="dropdown">
        <a href="/" class="dropdown-toggle" data-toggle="dropdown">
          <i class="material-icons">notifications</i>
          <span class="notification">5</span>
          <p class="hidden-lg hidden-md">Notificações</p>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a href="/">Mike John responded to your email</a>
          </li>
          <li>
            <a href="/">You have 5 new tasks</a>
          </li>
          <li>
            <a href="/">You're now friend with Andrew</a>
          </li>
          <li>
            <a href="/">Another Notification</a>
          </li>
          <li>
            <a href="/">Another One</a>
          </li>
        </ul>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsDropdown.js